import {
  initialState,
  Actions,
  State,
  NEW_SUPPORT_TASK,
  NEW_SUPPORT_TASK_SUCCESS,
  NEW_SUPPORT_TASK_ERROR,
  RESET_NEW_SUPPORT_TASK,
} from '../../types/support-tasks/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_SUPPORT_TASK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_SUPPORT_TASK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_SUPPORT_TASK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_SUPPORT_TASK:
      return initialState
    default:
      return state
  }
}

export default reducers
